import {CheckUsage} from "@/lib/queries/launchpad.ts";
import {ServiceDefinition, ServiceGroup} from "@/lib/types/checks.ts";
import {ChecksGroup} from "@/pages/launchpad/ChecksGroup.tsx";

interface ChecksPanelProps {
  monitoringServiceTypes: ServiceGroup[];
  serviceDefinitions: ServiceDefinition[];
  checksUsage: CheckUsage[];
}

export const ChecksPanel = ({monitoringServiceTypes, serviceDefinitions, checksUsage}: ChecksPanelProps) => {
  return (
    <div>
      <div className="row mb-4">
        <h5>Monitoring Checks</h5>
        <small className="text-muted">
          A Check monitors a URL or IP address at intervals as low as 1-minute, and issues alerts upon downtime
          detection
        </small>
      </div>
      <div className="row mb-2">
        {monitoringServiceTypes
          .filter((g) => g.group)
          .map((group, idx) => (
            <ChecksGroup
              key={`group-${idx}`}
              group={group}
              serviceDefinitions={serviceDefinitions}
              checksUsage={checksUsage}
            />
          ))}
      </div>
    </div>
  );
};
